export function extractBody(response) {
    return response.body;
}
//# sourceMappingURL=request.js.map